// extracted by mini-css-extract-plugin
export default {"root":"Purpose_root__6aonr","lastUpdated":"Purpose_lastUpdated__lDCoU marketplaceBodyFontStyles"};